import { schema } from "normalizr";
import { Collection } from "./collection";

export const Collections = new schema.Array(Collection);
